import React from 'react'
import { Container} from 'react-bootstrap'
import client from './../images/client.png'
import hirtline from './../images/client_logos/partner01.png'
import gysl from './../images/client_logos/partner02.png'
import andre from './../images/client_logos/partner03.png'
import molemab from './../images/client_logos/partner04.png'


const Client = () => {
    return (
        <Container>
            <div className="min-h-full items-center text-center sm:px-6 lg:px-8 w-full pb-5">
                <h1 className='text-3xl anton text-blue-900 pb-2'>Our Partners</h1>
                <p className="pb-4 text-lg">고객사</p>
                <img src={client} alt="hiearchy_image" id="hiearchy_image" className="m-0 w-full"/>
            </div>
            <div className="text-center bg-gray-50 border">
                <h1 className="font-bold text-xl text-blue-900">티엠케이와 함께성장할 수 있도록 노력하겠습니다.</h1>
                <div className="grid grid-cols-4 px-5 text-center py-4">
                    <div>
                        <img src={hirtline} className="object-fit-alt inline-block" alt="hirtline_logo"/>             
                    </div>
                    <div>
                        <img src={gysl} className="object-fit-alt inline-block" alt="hirtline_logo"/>             
                    </div>
                    <div>
                        <img src={andre} className="object-fit-alt inline-block" alt="hirtline_logo"/>             
                    </div>
                    <div>
                        <img src={molemab} className="object-fit-alt inline-block" alt="hirtline_logo"/>             
                    </div>
                </div>
            </div>
        </Container>
    )
}

export default Client
